<template>
  <hi-page>
    <hi-page-column card width="25vw" fix-width>
      <template v-slot:header>
        <hi-row flex>
          <div class="flex-grow-1">Email Templates</div>
          <div>Add New Custom Template</div>
        </hi-row>
      </template>
      <hi-row class="ui-text py-3 sec-title2" separator>System Emails</hi-row>
      <hi-list :items="systemTemplates" @select="selectSystemTemplate">
        <template v-slot="{ item }">
          <v-list-item-content>
            {{ item.name }}
            <small
              >({{ item.project }})
              <span v-if="item.default"> - default</span></small
            >
          </v-list-item-content>
        </template>
      </hi-list>
    </hi-page-column>
    <hi-page-column card width="25vw" fix-width v-if="currentTemplate">
      <email-template-markdown-editor
        :template="currentTemplateHtml"
        v-model="renderedHtml"
        :slot-values="currentSlotValues"
        @change="slotValueChange"
      ></email-template-markdown-editor>
      <template v-slot:footer>
        <hi-row flex>
          <v-btn small text>Reload Template</v-btn>
          <v-spacer />
          <v-btn small text @click="save" :disabled="updatingSystemTemplate"
            >Save Changes</v-btn
          >
        </hi-row>
      </template>
    </hi-page-column>
    <hi-page-column card grow v-if="currentTemplate">
      <email-viewer :html="renderedHtml"></email-viewer>
    </hi-page-column>
  </hi-page>
</template>
<script>
import HiPage from "@/components/scaffold/HiPage";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import HiRow from "@/components/scaffold/HiRow";

import { mapActions, mapGetters } from "vuex";
import HiList from "@/components/HiList";
import EmailViewer from "@/components/emails/EmailViewer";
// import { api } from "@/api";
import EmailTemplateMarkdownEditor from "@/components/emails/EmailTemplateMarkdownEditor";

export default {
  name: "EmailTemplates",
  components: {
    EmailTemplateMarkdownEditor,
    EmailViewer,
    HiList,
    HiRow,
    HiPageColumn,
    HiPage
    // LeadDetails,
    // LeadComments
  },
  data() {
    return {
      // selectedItem: null,
      // selectedType: null,
      // templateHtml: null,
      renderedHtml: null
    };
  },
  methods: {
    ...mapActions("emailTemplates", [
      "fetch",
      "selectSystemTemplate",
      "setCurrentSlotValues",
      "saveSystemTemplate"
    ]),
    slotValueChange(slotValues) {
      this.setCurrentSlotValues(slotValues);
    },
    save() {
      this.saveSystemTemplate(this.renderedHtml);
    }
  },
  computed: {
    ...mapGetters("emailTemplates", [
      "systemTemplates",
      "customTemplates",
      "updatingSystemTemplate",
      "currentTemplateHtml",
      "currentSlotValues",
      "currentPreviewHtml",
      "currentTemplate"
    ])
    // previewHtml() {
    //   if (!this.selectedItem) return null;
    //   if (this.renderedHtml) return this.renderedHtml;
    //   if (this.selectedItem.html) return this.selectedItem.html;
    //   if (this.templateHtml) return this.templateHtml;
    //   return null;
    // }
  },
  created() {
    this.fetch();
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
@import "~@/styles/fullHeightVTabs.scss";
</style>
